import {
  Box,
  Pagination,
  Select,
  MenuItem,
  Modal,
  Typography,
  CircularProgress,
} from "@mui/material";
import { useEffect, useState } from "react";
import TableMuiCustom from "../mui/TableMuiCustom";
import { getHistory } from "../api/history";
import ExportHistoryModal from "./ExportHistoryModal";
import { selectAdmin } from "../redux/adminSlice";
import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";

function History() {
  const admin = useSelector(selectAdmin);

  if(admin?.userRole !== "Admin") {
    return <Navigate to="/admin/UltimateHoldingCompany" />;
  }
  const [loading, setLoading] = useState(false);
  const [historyData, setHistoryData] = useState([]);
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [totalCount, setTotalCount] = useState(0);

  // New state for Modal
  const [openModal, setOpenModal] = useState(false);
  const [selectedHistory, setSelectedHistory] = useState(null);

  const [isModalOpen, setIsModalOpen] = useState(false);

  useEffect(() => {
    async function loadData() {
      setLoading(true);
      try {
        const res = await getHistory({ page, limit: pageSize });
        const historyList = res?.data?.history || [];
        const pagination = res?.data?.pagination || {};

        setHistoryData(
          historyList?.map((item, index) => ({
            data: { ...item, id: (page - 1) * pageSize + index + 1 },
          }))
        );

        setTotalCount(pagination.total || 0);
      } catch (error) {
        console.error("Failed to load history", error);
      } finally {
        setLoading(false);
      }
    }

    loadData();
  }, [page, pageSize]);

  const handleView = (row) => {
    setSelectedHistory(row);
    setOpenModal(true);
  };

  const handleCloseModal = () => {
    setOpenModal(false);
    setSelectedHistory(null);
  };

  return <>
    <div>
      <div className="add-new d-flex align-items-end justify-content-end"></div>
      <div className="p-sm-3">
        <div className="d-flex align-items-center justify-content-between mb-3">
          <h3 className="fw-bold mb-0">History</h3>
          <button onClick={() => setIsModalOpen(true)} className="btn btn-outline-primary">
            Export CSV
          </button>
        </div>

        <ExportHistoryModal
          isOpen={isModalOpen}
          onClose={() => setIsModalOpen(false)}
          data={historyData}
        />

        <div className="w-100" style={{ position: 'relative', minHeight: '400px' }}>
          {loading ? (
            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '400px' }}>
              <CircularProgress size={80} sx={{ color: '#003B93' }} />
            </Box>
          ) : (
            <TableMuiCustom
            td={historyData}
            styleTableTh={{ fontWeight: "bold" }}
            styleTableContainer={{ minWidth: "800px" }}
            TableHead={{
              borderRadius: "10px",
              color: "black",
              fontWeight: "bold",
            }}
            styleTableThead={{
              backgroundColor: "white",
              color: "black",
              fontWeight: "bold",
            }}
            th={{
              index: "ID",
              action: "Action",
              actionBy: "Action By",
              role: "Role",
              tab: "Tab",
              status: "Status",
              time: "Time",
              viewBtn: "Details",
            }}
            customFields={[
              {
                name: "index",
                data: (value, row, index) => <Box>{row?.id}</Box>,
              },
              {
                name: "action",
                data: (value, row) => <Box>{row?.action}</Box>,
              },
              {
                name: "actionBy",
                data: (value, row) => (
                  <Box>
                    {row?.actionBy?.firstName
                      ? `${row?.actionBy?.firstName} ${row?.actionBy?.lastName}`
                      : "System"}
                  </Box>
                ),
              },
              {
                name: "role",
                data: (value, row) => <Box>{row?.role}</Box>,
              },
              {
                name: "tab",
                data: (value, row) => <Box>{row?.tab}</Box>,
              },
              {
                name: "status",
                data: (value, row) => (
                  <Box
                    style={{
                      color: row?.status === "success" ? "green" : "red",
                    }}
                  >
                    {row?.status}
                  </Box>
                ),
              },
              {
                name: "time",
                data: (value, row) => (
                  <Box>{new Date(row?.createdAt).toLocaleString()}</Box>
                ),
              },
              {
                name: "viewBtn",
                data: (value, row) => (
                  <Box className="d-flex justify-content-between align-items-center">
                    <button
                      onClick={() => handleView(row)}
                      style={{ backgroundColor: "#003B93", color: "white" }}
                      className="btn"
                    >
                      View
                    </button>
                  </Box>
                ),
              },
            ]}
          />
          )}
        </div>

        <Box
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          mt={2}
        >
          <Pagination
            count={Math.ceil(totalCount / pageSize)}
            page={page}
            onChange={(e, value) => setPage(value)}
            color="primary"
          />
          <Select
            value={pageSize}
            onChange={(e) => {
              setPageSize(Number(e.target.value));
              setPage(1);
            }}
            size="small"
            sx={{
              color: "#003B93",
              ".MuiOutlinedInput-notchedOutline": {
                borderColor: "#003B93",
              },
              "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                borderColor: "#003B93",
              },
              "&:hover .MuiOutlinedInput-notchedOutline": {
                borderColor: "#003B93",
              },
              ".MuiSvgIcon-root": {
                color: "#003B93",
              },
            }}
          >
            <MenuItem value={5}>5</MenuItem>
            <MenuItem value={10}>10</MenuItem>
            <MenuItem value={20}>20</MenuItem>
            <MenuItem value={50}>50</MenuItem>
            <MenuItem value={100}>100</MenuItem>
            <MenuItem value={150}>150</MenuItem>
            <MenuItem value={200}>200</MenuItem>
          </Select>
        </Box>
      </div>
    </div>

    {/* Modal */}
    <Modal
      open={openModal}
      onClose={handleCloseModal}
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Box
        sx={{
          width: "65%",
          maxWidth: "1200px",
          bgcolor: "background.paper",
          borderRadius: 2,
          boxShadow: 24,
          p: 0,
          maxHeight: "90vh",
          display: "flex",
          flexDirection: "column",
        }}
      >
        <Box
          sx={{
            padding: 4,
            overflowY: "auto",
            flexGrow: 1,
          }}
        >
          {selectedHistory ? (
            <>
              <Typography
                variant="h6"
                mb={2}
                textAlign="center"
                fontWeight="bold"
              >
                History Details
              </Typography>

              <Box my={2} borderBottom="1px solid #ccc" />

              {["previousData", "newData"]?.map((dataType) => (
                <Box key={dataType} mt={3}>
                  <Typography variant="h6" mb={1} fontWeight="bold">
                    {dataType === "previousData"
                      ? "Previous Data"
                      : "New Data"}
                  </Typography>

                  {selectedHistory[dataType] &&
                  Object.keys(selectedHistory[dataType]).length > 0 ? (
                    <Box
                      component="table"
                      sx={{
                        width: "100%",
                        borderCollapse: "collapse",
                        border: "1px solid #ccc",
                      }}
                    >
                      <thead>
                        <tr>
                          {Object.keys(selectedHistory[dataType])?.map(
                            (key) => {
                              const formattedKey = key
                                .replace(/([A-Z])/g, " $1")
                                .replace(/_/g, " ")
                                .replace(/\b\w/g, (char) =>
                                  char.toUpperCase()
                                );
                              return (
                                <th
                                  key={key}
                                  style={{
                                    border: "1px solid #ccc",
                                    padding: "8px",
                                    backgroundColor: "#f5f5f5",
                                    fontWeight: "bold",
                                    textAlign: "left",
                                  }}
                                >
                                  {formattedKey}
                                </th>
                              );
                            }
                          )}
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          {Object.values(selectedHistory[dataType])?.map(
                            (value, idx) => (
                              <td
                                key={idx}
                                style={{
                                  border: "1px solid #ccc",
                                  padding: "8px",
                                }}
                              >
                                {value !== null && value !== undefined
                                  ? String(value)
                                  : "-"}
                              </td>
                            )
                          )}
                        </tr>
                      </tbody>
                    </Box>
                  ) : (
                    <Typography>
                      No {dataType === "previousData" ? "previous" : "new"}{" "}
                      data available.
                    </Typography>
                  )}
                </Box>
              ))}
            </>
          ) : (
            <Typography>Loading...</Typography>
          )}
        </Box>

        {/* Fixed footer with Close button */}
        <Box
          sx={{
            borderTop: "1px solid #ccc",
            padding: 2,
            textAlign: "right",
          }}
        >
          <button
            onClick={handleCloseModal}
            style={{
              backgroundColor: "#003B93",
              color: "white",
              padding: "8px 16px",
              borderRadius: "5px",
              border: "none",
              cursor: "pointer",
            }}
          >
            Close
          </button>
        </Box>
      </Box>
    </Modal>

    {/* <LoadingOverlay open={loading} /> */}
  </>;
}

export default History;
